<template>
 <svg
  width="163"
  height="50"
  viewBox="0 0 163 50"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    x="0.5"
    y="0.5"
    width="162"
    height="49"
    rx="11.5"
    fill="#5AC2F2"
    stroke="white"
  />
  <text v-if="color ==='red'"
    x="50%"
    y="50%"
    dominant-baseline="middle"
    text-anchor="middle"
    font-family="Arial, sans-serif"
    font-size="14"
    fill="white"
    style="font-weight: bold;"
  >
  Знято з продажу
  </text>
  <text v-else
    x="50%"
    y="50%"
    dominant-baseline="middle"
    text-anchor="middle"
    font-family="Arial, sans-serif"
    font-size="14"
    fill="white"
    style="font-weight: bold;"
  >
  Продано
  </text>
</svg>
</template>

<script>
export default {
  name: 'SoldMarked',
  props: {
    color: String
  },
}
</script>
<style scoped></style>
